module.exports = __webpack_public_path__ + "img/warningIntegration.5af04d8b.svg";